import { render } from "./ContentWrapperControl.vue?vue&type=template&id=aa3db056"
import script from "./ContentWrapperControl.vue?vue&type=script&lang=js"
export * from "./ContentWrapperControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__